import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getNotificationFormInputs } from "../model/notification.modal";
import { menuUrl } from "../notification-list/model/notification-list.constants";
import { editNotificationApi } from "./notification-edit.component.service";
import { getAllUsers } from "../notification-create/notification-create.component.service";
import NotificationEditTemplateComponent from "./notification-edit-template.component";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  NOTIFICATION_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const NotificationEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });
  const [formInputs, setFormInputs] = useState([]);
  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleNotificationSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct users payload
    let notificationPayload = {};
    for (let i = 0; i < values.length; i++) {
      notificationPayload[values[i].name] = values[i].value;
    }

    // INFO : call edit api
    const notificationResponse = await editNotificationApi(
      location?.state?.row[PRIMARY_KEY],
      notificationPayload
    );

    // INFO : check api response and show relevant alert message
    if (notificationResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: notificationResponse.message })
      );
    }
  };

  const onLoad = async () => {
    const usersListResponse = await getAllUsers();
    // console.log({ usersListResponse });
    if (usersListResponse.status) {
      const formatedUserList = usersListResponse.data.map((data) => {
        return {
          name: data.name,
          value: data[PRIMARY_KEY],
        };
      });

      const formInputData = getNotificationFormInputs(formatedUserList, {
        message: location?.state?.row?.message || "",
        redirect: location?.state?.row?.redirect || "",
        adminId: location?.state?.row?.admin_id || "",
        status: location?.state?.row?.status || "",
      });
      // console.log({ formatedUserList, formInputData });
      setFormInputs(formInputData);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleNotificationSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <NotificationEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default NotificationEditComponent;
